import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputNumbersmall, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { errorStyles } from '../../Utils/table';
import { fetchStitchingReg, StitchingReturns } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchReg } from '../Selectors/StitchSelector/StitchingSelectors';


const StitchingReturn = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        stId: parseInt(Id),
        dt: '',
        brandId: '',
        brandNm: '',
        departId: '',
        departNm: '',
        empId: '',
        empNm: '',
        instruction: '',
        itemId: '',
        itemNm: '',
        userId: userdata?.userId,
        partyId: '',
        partyNm: '',
        piMemo: '',
        pinwId: '',
        stMemo: '',
        totqty: '',
        totmat: '',
        totmatuse: '',
        totmatbal: '',
        reqty: '',
        remainqty: '',
        remainqty2: '',
    });
    const [errors, setErrors] = useState({});
    const [material, setMaterial] = useState([]);
    const [itemQty, setItemQty] = useState([]);
    const dispatch = useDispatch();
    const stitchlist = useSelector(selectStitchReg);

    useEffect(() => {
        dispatch(fetchStitchingReg(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (stitchlist?.data) {
            const item = stitchlist?.data;
            const reCount = parseFloat(stitchlist?.stIdCount) + 1;
            setFormData(prev => ({
                ...prev,
                brandId: item.brandId,
                brandNm: item.brandNm,
                departId: item.departId,
                departNm: item.departNm,
                empId: item.empId,
                empNm: item.empNm,
                instruction: item.instruction,
                itemId: item.itemId,
                itemNm: item.itemNm,
                partyId: item.partyId,
                partyNm: item.partyNm,
                piMemo: item.piMemo,
                pinwId: item.pinwId,
                stMemo: item.stMemo,
                totqty: item.qty,
                remainqty: item.balqty,
                remainqty2: item.balqty,
                reMemo: reCount !== 1 ? `R-${item.stMemo}-${reCount}` : `R-${item.stMemo}`,

            }));
        }
        if (stitchlist?.Info2?.length > 0) {
            let data = JSON.parse(JSON.stringify(stitchlist?.Info2));
            setMaterial(data);
            const totsum = data?.reduce((acc, val) => acc + parseFloat(val.balqty), 0);
            setFormData(prev => ({
                ...prev,
                totmat: totsum
            }));
        }
        if (stitchlist?.Info.length > 0) {
            const valuess = JSON.parse(JSON.stringify(stitchlist?.Info));
            setItemQty(valuess);
        }
    }, [stitchlist]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
        let rmqty = parseFloat(formData.remainqty2);
        if (name === 'reqty' && value <= rmqty) {
            const remainqty = rmqty - parseFloat(value);
            setFormData(prev => ({
                ...prev,
                remainqty: remainqty || 0
            }));
        } else {
            alert(`Remain Qty ${formData.remainqty2}`);
            setFormData(prev => ({
                ...prev,
                reqty: '',
                remainqty: rmqty
            }));
        }
    };

    const handleRemainQtyChange = (e, index) => {
        const newRemainQty = Number(e.target.value);
        const updatedMaterials = [...material];

        // Ensure the remain qty is not greater than balqty
        if (newRemainQty > updatedMaterials[index].balqty) {
            alert('Remain Quantity cannot be greater than Balance Quantity');
            return; // Exit if the remain qty is invalid
        }

        // Update the remain qty and calculate use qty (balqty - remainqty)
        updatedMaterials[index].useqty = newRemainQty;
        updatedMaterials[index].remainqty = updatedMaterials[index].balqty - newRemainQty;

        setMaterial(updatedMaterials);

        const totusedqty = updatedMaterials?.reduce((acc, use) => acc + parseFloat(use.useqty || 0), 0);
        const totbalqty = updatedMaterials?.reduce((acc, bal) => acc + parseFloat(bal.remainqty || 0), 0);
        setFormData(prev => ({
            ...prev,
            totmatbal: totbalqty,
            totmatuse: totusedqty
        }));
    };

    const handleRqtyChange = (e, index) => {
        const newRqty = Number(e.target.value);
        const updatedItems = [...itemQty];

        // Ensure the rqty is not greater than balqty
        if (newRqty > updatedItems[index].balqty) {
            alert('Return Quantity cannot be greater than Given Quantity');
            return; // Exit if the entered rqty is invalid
        }

        // Update the rqty and calculate remainqty (balqty - rqty)
        updatedItems[index].rqty = newRqty;
        updatedItems[index].remainqty = updatedItems[index].balqty - newRqty;

        setItemQty(updatedItems);
        const totrqty = updatedItems?.reduce((acc, val) => acc + parseFloat(val.rqty || 0), 0);
        // console.log(totrqty);
        const remainqty = parseFloat(formData.remainqty2) - totrqty;
        setFormData(prev => ({
            ...prev,
            reqty: totrqty,
            remainqty: remainqty
        }));
    };

    function convertIntoOneObject(formData, itemQty, material) {
        const data = {
            stId: formData.stId,
            dt: formData.dt,
            brandId: formData.brandId,
            departId: formData.departId,
            empId: formData.empId,
            instruction: formData.instruction,
            itemId: formData.itemId,
            userId: formData.userId,
            partyId: formData.partyId,
            reMemo: formData.reMemo,
            stMemo: formData.stMemo,
            gtotqty: formData.totqty,
            reqty: formData.reqty,
            remainqty: formData.remainqty,
            itemQty: itemQty,
            material: material,
            totmatuse: formData.totmatuse,
            totmatbal: formData.totmatbal
        };
        return data;
    }

    const fields = [
        { label: 'Stitch Memo', name: 'stMemo' },
        { label: 'Party', name: 'partyNm' },
        { label: 'Department', name: 'departNm' },
        { label: 'Master', name: 'empNm' },
        { label: 'Item', name: 'itemNm' },
        { label: 'Brand', name: 'brandNm' },
        { label: 'Issue Qty.', name: 'totqty' },
        { label: 'Remain Qty.', name: 'remainqty' },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.dt || formData.dt.trim() === '') {
            alert("Date is required.");
            return; // Stop the submission if validation fails
        }
        if (!formData.reqty || formData.reqty === '') {
            alert("Enter Return Qty is required.");
            return; // Stop the submission if validation fails
        }
        const finalObject = convertIntoOneObject(formData, itemQty, material);
        // console.log(finalObject)
        dispatch(StitchingReturns(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Job Return Added");
                window.close();

            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Job Return Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Return Memo', name: 'reMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {fields.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id={field.name}
                                                    >
                                                        {formData[field.name] || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                {[

                                    { label: 'Return Qty.', name: 'reqty' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={6}></Grid>
                                {material.length > 0 &&
                                    <div style={{ marginTop: '1vw' }}>
                                        <h3>Material Details </h3>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Material Work</th>
                                                    <th>Given Qty.</th>
                                                    <th>Return Qty.</th>
                                                    <th>Bal Qty.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {material?.map((mat, matIndex) => (
                                                    <>
                                                        <tr key={matIndex}>
                                                            <td>
                                                                {matIndex + 1}
                                                            </td>
                                                            <td>
                                                                {mat.materialNm}
                                                            </td>
                                                            <td>
                                                                {mat.balqty}
                                                            </td>
                                                            <td>
                                                                {/* {mat.useqty} */}
                                                                <input
                                                                    type="text"
                                                                    placeholder="0"
                                                                    value={mat.useqty}
                                                                    onChange={(e) => handleRemainQtyChange(e, matIndex)}
                                                                    style={{ width: '60px' }}
                                                                />
                                                            </td>
                                                            <td>
                                                                {/* <input
                                                                type="text"
                                                                placeholder="0"
                                                                value={mat.remainqty}
                                                                onChange={(e) => handleRemainQtyChange(e, matIndex)}
                                                                style={{ width: '60px' }}
                                                            /> */}
                                                                {mat.remainqty}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))}
                                                <tr>
                                                    <td> </td>
                                                    <td>
                                                        <span className="tot-lump">Total Qty</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmat}</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmatuse}</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmatbal}</span>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>}

                                {itemQty?.length > 0 && <div style={{ marginTop: '1vw' }}>
                                    <h3>Item Details</h3>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>Size</td>
                                                {itemQty?.map((val, valIndex) => (
                                                    <td key={valIndex}>
                                                        {val.size}
                                                    </td>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td>Given Qty.</td>
                                                {itemQty?.map((val, valIndex) => (
                                                    <td key={valIndex}>
                                                        {val.balqty}
                                                    </td>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td>Return Qty.</td>
                                                {itemQty?.map((val, valIndex) => (
                                                    <td key={valIndex}>
                                                        <input
                                                            type="text"
                                                            placeholder="0"
                                                            value={val.rqty || ''}
                                                            onChange={(e) => handleRqtyChange(e, valIndex)}
                                                            style={{ width: '50px' }}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td>Bal Qty.</td>
                                                {itemQty?.map((val, valIndex) => (
                                                    <td key={valIndex}>
                                                        {val.remainqty}
                                                    </td>
                                                ))}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                }


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid >
            </div >
        </>
    );
}

export default StitchingReturn;
